import React from 'react';
import { mockFAQs } from '../mock';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../components/ui/accordion';

const FAQ = () => {
  return (
    <section id="faq" className="bg-black py-20">
      <div className="max-w-[900px] mx-auto px-[7.6923%]">
        <div className="text-center mb-16">
          <h2 className="text-[48px] font-semibold leading-[1.1] tracking-[-0.02em] text-white mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-[20px] font-medium leading-[1.5] text-[rgba(255,255,255,0.85)]">
            Everything you need to know about PIOFarming Game
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full space-y-4">
          {mockFAQs.map((faq, index) => (
            <AccordionItem
              key={index}
              value={`item-${index}`}
              className="border border-[rgba(255,255,255,0.25)] bg-[rgba(255,255,255,0.05)] px-6 data-[state=open]:border-[#00FFD1]"
            >
              <AccordionTrigger className="text-[20px] font-semibold text-white hover:text-[#00FFD1] hover:no-underline py-6">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-[18px] font-normal leading-[1.5] text-[rgba(255,255,255,0.85)] pb-6">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;
